
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const CTASection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section ref={ref} className="py-24 bg-gradient-to-r from-primary-sage to-primary-gold relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className="relative z-10 max-w-4xl mx-auto px-6 lg:px-12 text-center"
      >
        <h2 className="font-serif font-bold text-4xl lg:text-5xl text-white mb-6">
          Ready to Elevate Your Journey?
        </h2>
        <p className="text-xl text-white/90 mb-10">
          Book a free 30-minute discovery call today and let's discuss how we can work together to achieve your goals.
        </p>

        <Link
          to="/contact"
          className="inline-flex items-center justify-center px-10 py-5 bg-white text-primary-charcoal hover:bg-primary-beige font-bold text-lg rounded-lg transition-all duration-300 shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
        >
          Schedule Your Call
          <i className="ri-calendar-check-line ml-3 text-xl"></i>
        </Link>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 mt-10">
          <a
            href="mailto:titilayoajayi923@gmail.com"
            className="flex items-center space-x-2 text-white hover:text-white/80 transition-colors cursor-pointer"
          >
            <i className="ri-mail-line text-xl"></i>
            <span className="font-medium">Email</span>
          </a>
          <span className="hidden sm:block text-white/50">|</span>
          <a
            href="tel:+2349060814354"
            className="flex items-center space-x-2 text-white hover:text-white/80 transition-colors cursor-pointer"
          >
            <i className="ri-phone-line text-xl"></i>
            <span className="font-medium">Phone</span>
          </a>
          <span className="hidden sm:block text-white/50">|</span>
          <a
            href="https://wa.me/2349047390448"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-white hover:text-white/80 transition-colors cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            <span className="font-medium">WhatsApp</span>
          </a>
        </div>
      </motion.div>
    </section>
  );
};

export default CTASection;
